module.exports = __webpack_public_path__ + "img/mobile-logo.9240fde3.svg";